







import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { TCourseInfo } from '@/types/views/educational';
import { getCourseById } from '@/api/educational';
@Component({
  components: {
    Info: () => import('./modules/course-detail/info.vue'),
    Lesson: () => import('./modules/course-detail/lesson.vue'),
    Student: () => import('./modules/course-detail/student.vue')
  }
})
export default class Detail extends Vue {
  private courseInfo: TCourseInfo = {};
  private courseId = '0';
  private orgId = '';
  private activated() {
    this.courseId = this.$route.params.id;
    this.getCourseInfo();
  }
  private async getCourseInfo() {
    try {
      let res: any = await getCourseById({
        courseId: this.courseId
      });

      this.courseInfo = res;
      this.orgId = String(res.orgId)
      this.handleCourseInfo();
    } catch (e) {
      this.$message.error(e.message);
    }
  }
  private handleCourseInfo() {
    const { mainTeacher, assitantTeacher } = this.courseInfo;
    if (!mainTeacher) this.courseInfo.mainTeacher = {};
    if (!assitantTeacher) this.courseInfo.assitantTeacher = {};
  }
}
